// extracted by mini-css-extract-plugin
export var counter = "Progress-module--counter--+vK8k";
export var counter__progress = "Progress-module--counter__progress--yqex-";
export var counter__progress__value = "Progress-module--counter__progress__value--xyj3g";